import { render, staticRenderFns } from "./myprice.vue?vue&type=template&id=53c0e58a&scoped=true&"
import script from "./myprice.vue?vue&type=script&lang=js&"
export * from "./myprice.vue?vue&type=script&lang=js&"
import style0 from "./myprice.vue?vue&type=style&index=0&id=53c0e58a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0e58a",
  null
  
)

export default component.exports